module.exports = __webpack_public_path__ + "static/media/grooveyard.518d6a11.png";